<div class="flex flex-col gap-2">
  <div>
    <div class="relative w-full border border-gray-200 pt-[100%]">
      <div class="absolute inset-0 px-3">
        <app-image-thumbnail size="full">
          <img
            [alt]="image().alt"
            [fill]="true"
            [ngSrc]="image().url"
            class="object-contain" />
        </app-image-thumbnail>
      </div>
    </div>
  </div>

  <div>
    <app-router-link
      [params]="routerLinkParams()"
      [route]="Route.PL_CosmeticDetails">
      <div class="hover:underline">
        <div class="flex flex-col">
          <app-router-link
            [params]="routerLinkParams()"
            [route]="Route.PL_CosmeticDetails">
            {{ name() }}
          </app-router-link>
        </div>
      </div>
    </app-router-link>
  </div>

  <div class="mt-auto">
    @for (box of boxes(); track box.id) {
      <app-router-link
        [route]="Route.PL_BoxDetails"
        [params]="prepareBoxParams(box)">
        <div class="text-sm uppercase hover:underline">
          {{ box.name }}
        </div>
      </app-router-link>
    }

    <div class="flex justify-end text-2xl">
      <app-router-link
        [params]="routerLinkParams()"
        [route]="Route.PL_CosmeticDetails">
        <span
          pTooltip="Więcej o produkcie"
          tooltipPosition="bottom">
          <app-icon [icon]="Icon.ThreeDots" />
        </span>
      </app-router-link>
    </div>
  </div>
</div>
